<template>
    <h1>Blog personal</h1>
</template>
<script>
    export default{
        name: "BlogHeader",
    }
</script>
<style>
.BlogHeader {
    font-size: 100px;
}
</style>
